// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"e615caa4","178":"1b8db79f","218":"519e52be","233":"9c2d2fe6","398":"12dbfe4a","682":"e50c94e2","854":"c670772d","942":"2d223105"}[chunkId] + ".chunk.js";
};